import { render, staticRenderFns } from "./AppToolbar.vue?vue&type=template&id=1dbb060a&"
import script from "./AppToolbar.vue?vue&type=script&lang=js&"
export * from "./AppToolbar.vue?vue&type=script&lang=js&"
import style0 from "./AppToolbar.vue?vue&type=style&index=0&id=1dbb060a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports